module.exports = __webpack_public_path__ + "9b673c9dadc7a5e70838e8e358daa4cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/vergleich.png
// module id = 55
// module chunks = 1